// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// 브라우저 기본 검증 말풍선 한국어화 (문서 전역에 한 번)
import "./native_validation_ko"

// 세션 만료 시 ajax 401 을 사용자에게 알린다 (문서 전역에 한 번)
import "./session_expired_notice"

// Tom Select (for Autocomplete component)
import "tom-select/dist/css/tom-select.css"

// Lucide Icons (사용하는 아이콘만 import하여 번들 크기 최적화)
import {
  createIcons,
  AlertCircle, AlertTriangle, ArrowLeft, ArrowRight,
  BarChart3, Bell, Building2,
  Calculator, Camera, Check, CheckCheck, CheckCircle, CheckCircle2, ChevronDown, ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight,
  Circle, CircleHelp, ClipboardCheck, ClipboardList, Clock, Construction, Copy, CreditCard,
  Download, Edit3, ExternalLink,
  FileCheck, FileSpreadsheet, FileText, Filter, FlaskConical, FolderInput, FolderOpen,
  HardHat,
  Image, Info,
  Key,
  LayoutDashboard, ListChecks, Loader, Lock,
  Megaphone, MessageCircle, MessageCircleWarning, MinusCircle,
  Package, Pencil, Plus, Printer,
  RefreshCw, Repeat, RotateCcw,
  Save, Scale, Search, Settings, Share2, ShieldAlert, ShieldCheck, SkipForward, Smartphone, Star,
  TestTubes, Trash2,
  Unlink, Upload, UploadCloud, User, UserCheck, UserCog, Users,
  X, XCircle
} from "lucide"

// 사용할 아이콘 목록
const icons = {
  AlertCircle, AlertTriangle, ArrowLeft, ArrowRight,
  BarChart3, Bell, Building2,
  Calculator, Camera, Check, CheckCheck, CheckCircle, CheckCircle2, ChevronDown, ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight,
  Circle, CircleHelp, ClipboardCheck, ClipboardList, Clock, Construction, Copy, CreditCard,
  Download, Edit3, ExternalLink,
  FileCheck, FileSpreadsheet, FileText, Filter, FlaskConical, FolderInput, FolderOpen,
  HardHat,
  Image, Info,
  Key,
  LayoutDashboard, ListChecks, Loader, Lock,
  Megaphone, MessageCircle, MessageCircleWarning, MinusCircle,
  Package, Pencil, Plus, Printer,
  RefreshCw, Repeat, RotateCcw,
  Save, Scale, Search, Settings, Share2, ShieldAlert, ShieldCheck, SkipForward, Smartphone, Star,
  TestTubes, Trash2,
  Unlink, Upload, UploadCloud, User, UserCheck, UserCog, Users,
  X, XCircle
}

// 글로벌 접근용 (Stimulus 컨트롤러, 인라인 스크립트 호환)
window.lucide = { createIcons: (opts = {}) => createIcons({ icons, ...opts }) }

// 페이지 로드 및 Turbo 네비게이션 시 아이콘 초기화
function initLucideIcons() {
  createIcons({ icons })
}

document.addEventListener("DOMContentLoaded", initLucideIcons)
document.addEventListener("turbo:load", initLucideIcons)
document.addEventListener("turbo:render", initLucideIcons)
document.addEventListener("turbo:frame-load", initLucideIcons)

// Turbo Drive 는 페이지 reload 후 URL anchor 로 자동 scroll 하지 않으므로 직접 처리.
// redirect 후 #section 위치 유지를 위해 turbo:load 시점에 anchor 요소로 scrollIntoView.
function scrollToAnchor() {
  if (!window.location.hash) return
  const el = document.querySelector(window.location.hash)
  if (!el) return
  // 비동기로 한 틱 미루어 layout 완료 후 정확히 위치 잡기
  requestAnimationFrame(() => el.scrollIntoView({ behavior: "instant", block: "start" }))
}
document.addEventListener("turbo:load", scrollToAnchor)
document.addEventListener("DOMContentLoaded", scrollToAnchor)

// Note: jQuery and Fomantic UI are loaded via CDN in layout for proper initialization order
